export const FilterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
      <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
        <path d="M15 5a2 2 0 0 0-2 2v.875H4v1.25h9V10a2 2 0 1 0 4 0v-.875h3v-1.25h-3V7a2 2 0 0 0-2-2m.75 5V7a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0M20 16.125v-1.25h-9V14a2 2 0 1 0-4 0v.875H4v1.25h3V17a2 2 0 1 0 4 0v-.875zM8.25 17v-3a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-1.5 0"></path>
      </g>
    </g>
  </svg>
);
